<template>
  <v-card>
    <v-data-table
      :headers="headers"
      :items="dados"
      :server-items-length="total"
      :options.sync="options"
      disable-sort
      loading-text="Carregando... Por favor aguarde"
      :loading="carregando"
      class="elevation-1 base_table mt-4"
      :footer-props="{
        itemsPerPageOptions: [5,10,15,20,25,50,100],
        showFirstLastPage: true,
        firstIcon: 'skip_previous',
        lastIcon: 'skip_next',
        prevIcon: 'chevron_left',
        nextIcon: 'chevron_right'
      }"
      :header-props="{
        sortIcon: 'north',
      }"
    >
      <template v-slot:top>
        <v-row align="center" justify="space-between" class="mb-2">
          <v-col cols="12" md="11">
            <v-row no-gutters align="center">
              <v-col cols="12" class="pt-0" md="4" :class="$root.Permissions.admin() && etapas && etapas.length > 0 ? 'mb-3' : ''">
                <VueCtkDateTimePicker
                  position="bottom"
                  v-on:callback="changeDates"
                  v-model="data_entrada"
                  class="date-picker"
                  locale="pt-BR"
                  :no-header="true"
                  :no-value-to-custom-elem="true"
                  :overlay="true"
                  :range="true"
                  :formatted="'L'"
                  :format="'YYYY-MM-DD'"
                  color="#004A93"
                  :dark="$vuetify.theme.dark"
                  button-color="#004A93"
                  :custom-shortcuts="labels"
                  :no-button="true"
                  :noClearButton="true"
                  :auto-close="true"
                  :loading="loadingSearch"
                  :disabled="loadingSearch"
                  :submit="retornoData()"
                >
                  <v-btn class="px-2 ui-search_btn w-100" elevation="0" v-ripple="{ class: `success--text` }">
                    <b class="text">
                      Período: {{ formatDateFront(de, 'LL')}} - {{formatDateFront(ate, 'LL') }}
                    </b>
                  </v-btn>
                </VueCtkDateTimePicker>
              </v-col>
              <v-col cols="12" md="8" class="pt-0" v-if="$root.Permissions.admin() && etapas && etapas.length > 0"></v-col>
              <v-col cols="12" md="2" class="pt-0">
                <v-form @submit.prevent="buscaItens()">
                  <v-text-field
                    class="ml-2"
                    clearable
                    hide-details=""
                    clear-icon="close"
                    v-model="search"
                    outlined
                    label="Busca"
                    @click:clear="limparBusca()"
                  ></v-text-field>
                </v-form>
              </v-col>
              <v-col cols="12" md="2" class="pt-0" v-if="$root.Permissions.admin()">
                <v-autocomplete
                  class="ml-2"
                  :menu-props="{ offsetY: true}"
                  v-model="distribuidor"
                  :items="distribuidores"
                  hide-details=""
                  clearable
                  clear-icon="close"
                  label="Distribuidor"
                  append-icon="expand_more"
                  outlined
                  @change="applyFilter()"
                  @click:clear="applyFilter()"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="2" class="pt-0" v-if="$root.Permissions.admin()">
                <v-autocomplete
                  class="ml-2"
                  :menu-props="{ offsetY: true}"
                  v-model="integrador"
                  :items="integradores"
                  hide-details=""
                  clearable
                  clear-icon="close"
                  label="Integrador"
                  append-icon="expand_more"
                  outlined
                  @change="applyFilter()"
                  @click:clear="applyFilter()"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="2">
                <v-autocomplete
                  :menu-props="{ offsetY: true}"
                  v-model="tipo"
                  :items="tiposDeOportunidade"
                  clearable
                  class="ml-2"
                  clear-icon="close"
                  label="Tipo da oportunidade"
                  hide-details=""
                  append-icon="expand_more"
                  :loading="loadingSearch"
                  :disabled="loadingSearch"
                  outlined
                  @change="applyFilter()"
                  @click:clear="applyFilter()"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="2" v-if="etapas && etapas.length > 0">
                <v-autocomplete
                  :menu-props="{ offsetY: true}"
                  v-model="etapa"
                  :items="etapas"
                  clearable
                  class="ml-2"
                  clear-icon="close"
                  label="Etapa do funil"
                  hide-details=""
                  append-icon="expand_more"
                  :loading="loadingEtapas"
                  :disabled="loadingEtapas"
                  outlined
                  @change="applyFilter()"
                  @click:clear="applyFilter()"
                >
                </v-autocomplete>
              </v-col>
              <!-- <v-col cols="12" md="2" v-if="1 > 1">
                <v-autocomplete
                  :menu-props="{ offsetY: true}"
                  v-model="usuario"
                  :items="usuarios"
                  clearable
                  class="ml-2"
                  clear-icon="close"
                  label="Dono da oportunidade"
                  hide-details=""
                  append-icon="expand_more"
                  :loading="loadingUsuarios || loadingSearch"
                  :disabled="loadingUsuarios || loadingSearch"
                  outlined
                  @change="applyFilter()"
                  @click:clear="applyFilter()"
                >
                </v-autocomplete>
              </v-col> -->
            </v-row>
          </v-col>
          <v-col cols="12" md="1" class="text-right">
            <v-menu
              bottom
              center
              offset-y
              max-height="400"
            >
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on">
                  Exportar
                  <v-icon>arrow_drop_down</v-icon>
                </div>
              </template>
            <v-list>
                <v-list-item @click="exportXls()">
                  <v-list-item-icon class="mr-1">
                    <v-icon color="primary">receipt_long</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Exportar para XLS</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
        </v-row>
      </template>
      <template v-slot:item.cliente="{ item }">
        <span class="item-link" @click="goToContact(item.cliente.uuid_cli_id)">
          {{ item.cliente ? item.cliente.cli_nome : '' }}
        </span>
      </template>
      <template v-slot:item.status="{ item }">
        <v-chip small label :color="colors[item.status]" text-color="white">
          {{ item.status }}
        </v-chip>
      </template>
      <template v-slot:item.chance="{ item }">
        <v-chip small label :color="colors[item.chance]" text-color="white">
          {{ item.chance }}
        </v-chip>
      </template>
      <template v-slot:item.tarefa="{ item }">
        <span class="item-link" @click="goToOportunidade(item, '#atividades')" v-if="!!item.tarefa">
          {{ limitaTexto(item.tarefa.tar_descricao) }}
        </span>
        <span v-else> - </span>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-row no-gutters align="center" justify="center">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="goToOportunidade(item)" color="primary" class="ml-2">
                info
              </v-icon>
            </template>
            <span>Dados</span>
          </v-tooltip>
        </v-row>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import Api from '@API'
import moment from 'moment'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'

export default {
  props: ['status', 'cliente'],
  components: {
    VueCtkDateTimePicker
  },
  data () {
    return {
      search: '',
      searchFinal: '',
      total: 0,
      carregando: false,
      options: {},
      usuario: '',
      usuarios: [],
      loadingUsuarios: false,
      loadingSearch: false,
      dados: [],
      de: moment().subtract(90, 'days').format('YYYY-MM-DD'),
      ate: moment(new Date()).add(1, 'days').format('YYYY-MM-DD'),
      data_entrada: {
        start: moment().subtract(90, 'days').format('YYYY-MM-DD'),
        end: moment(new Date()).format('YYYY-MM-DD')
      },
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'opu_id'
        },
        { text: 'Contato', value: 'cliente' },
        { text: 'Dono da oportunidade', value: 'dono' },
        { text: 'Em aberto há:', value: 'opu_criado_em' },
        { text: 'Etapa do funil', value: 'etapa' },
        { text: 'Tipo', value: 'tipo' },
        { text: 'Chance de fechar', value: 'chance' },
        { text: 'Descrição', value: 'opu_observacao', width: '15%' },
        { text: 'Valor médio', value: 'valor' },
        { text: 'Próxima tarefa', value: 'tarefa', width: '15%' },
        { text: 'Integrador', value: 'integrador.int_nome' },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: 110
        }
      ],
      labels: [
        { key: 'thisDay', label: 'Hoje', value: 'day' },
        { key: 'last30Days', label: 'Últimos 30 dias', value: 30 },
        { key: 'thisMonth', label: 'Este mês', value: 'month' },
        { key: 'lastMonth', label: 'Mês passado', value: '-month' },
        { key: 'thisYear', label: 'Este ano', value: 'year' },
        { key: 'lastYear', label: 'Último ano', value: '-year' }
      ],
      tipo: null,
      tiposDeOportunidade: [
        {
          text: 'Sistema Fotovoltaico',
          value: 1
        },
        {
          text: 'Aquecedor Solar',
          value: 2
        },
        {
          text: 'Serviço',
          value: 3
        },
        {
          text: 'Carregador Veicular',
          value: 4
        }
      ],
      chances: ['Alta', 'Média', 'Baixa'],
      statuses: ['Aberta', 'Perdida', 'Fechada'],
      colors: {
        Aberta: 'blue',
        Perdida: 'red',
        Fechada: 'green',
        Baixa: 'red',
        Média: 'orange',
        Alta: 'green'
      },
      distribuidorAnterior: null,
      loadingDistribuidores: false,
      distribuidores: [],
      distribuidor: null,
      loadingIntegradores: false,
      integradores: [],
      integrador: null,
      integradorAnterior: null,
      funis: [],
      etapas: [],
      loadingEtapas: false,
      etapa: null
    }
  },
  watch: {
    options: {
      handler () {
        this.getOportunidades()
      },
      deep: true
    }
  },
  methods: {
    async exportXls () {
      this.loadingXls = true
      Api.post('relatorios/exportar', {
        headers: this.someHeader(),
        busca: this.searchFinal,
        distribuidor: this.distribuidor ? this.distribuidor : null,
        integrador: this.integrador ? this.integrador : null,
        tipo: this.tipo ? this.tipo : null,
        etapa: this.etapa ? this.etapa : null,
        status: this.status ? this.status : null,
        de: this.de ? this.de : null,
        ate: this.ate ? this.ate : null,
        type: 'oportunidades'
      })
        .then(res => {
          this.downloadXls(res.data.url)
          this.removeXls(res.data.url)
          this.loadingXls = false
        })
        .catch(err => {
          console.log(err)
          this.$root.SnackControl.open(this, {
            text: 'Ops, ocorreu um erro ao fazer o donwload!',
            color: 'error'
          })
        })
    },
    async downloadXls (url) {
      const a = document.createElement('a')
      a.href = url
      a.download = url.split('/').pop()
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    removeXls (url) {
      let data = {
        url: url
      }
      Api.post('relatorios/remove-s3', data)
    },
    someHeader () {
      let cabecalhos = []
      this.headers.map(header => {
        if (header.text !== 'ID' && header.text !== 'Ações' && header.text !== 'Usuários' && header.text !== 'Imagem') cabecalhos.push(header)
      })
      return cabecalhos
    },
    changeDates (dates) {
      this.de = dates.start
      this.ate = dates.end
    },
    formatDateFront (date, format = 'L') {
      return moment(date).format(format)
    },
    goToContact (uuid) {
      this.$router.push({ name: 'Contato', params: { uuid } }).catch(() => {})
    },
    goToOportunidade (item, tab = '') {
      this.$router.push(
        {
          name: 'OportunidadeInterna',
          params: { uuid: item.uuid },
          hash: tab
        }
      ).catch(() => {})
    },
    retornoData () {
      if (this.data_entrada.start !== this.de || this.data_entrada.end !== this.ate) {
        if (this.data_entrada.end !== null) {
          this.de = this.data_entrada.start
          this.ate = this.data_entrada.end
          this.applyFilter()
        }
      }
    },
    buscaItens () {
      this.searchFinal = this.search
      this.options.page = 1
      this.applyFilter()
    },
    limparBusca () {
      this.search = null
      this.searchFinal = null
      this.options.page = 1
      this.applyFilter()
    },
    async applyFilter () {
      if ((this.distribuidorAnterior && this.distribuidor !== this.distribuidorAnterior) ||
        (this.integradorAnterior && !this.integrador)) {
        this.integrador = null
        this.etapa = null
        this.etapas = []
      }

      this.loading = true
      let query = Object.assign({},
        this.de ? { de: this.de } : '',
        this.ate ? { ate: this.ate } : '',
        this.searchFinal ? { busca: this.searchFinal } : '',
        this.usuario ? { usuario: this.usuario } : '',
        this.tipo ? { tipo: this.tipo } : '',
        this.distribuidor ? { distribuidor: this.distribuidor } : '',
        this.integrador ? { integrador: this.integrador } : '',
        this.etapa ? { etapa: this.etapa } : '',
        this.cliente ? { uuid: this.cliente } : ''
      )

      let rota = 'OportunidadesAberto'
      if (this.status) {
        if (this.status === 2) rota = 'OportunidadesPerdidas'
        if (this.status === 3) rota = 'OportunidadesFechadas'
      }
      if (this.cliente) rota = 'Contato'

      this.$router.replace({name: rota, query: query}).catch(() => {})

      if (this.de) {
        this.data_entrada.start = this.de
        if (this.ate) {
          this.data_entrada.end = this.ate
        }
      }

      this.distribuidorAnterior = this.distribuidor
      this.getIntegrators(this.distribuidor)

      if (this.$root.Permissions.admin() && this.integrador !== this.integradorAnterior && this.integrador) {
        await this.getFunis()
        await this.getEtapas()
      }
      this.integradorAnterior = this.integrador

      this.getOportunidades()
    },
    async getOportunidades () {
      const { page, itemsPerPage } = this.options

      this.carregando = true
      this.total = 0
      this.dados = []

      let pagina = 1
      let parametros = ''
      let itensPagina = 10

      if (page) pagina = page
      if (itemsPerPage) itensPagina = itemsPerPage

      parametros = `?page=${pagina}&per_page=${itensPagina}`

      if (this.status) parametros += `&status=${this.status}`
      if (this.de) parametros += `&de=${this.de}`
      if (this.ate) parametros += `&ate=${this.ate}`
      if (this.searchFinal) parametros += `&busca=${this.searchFinal}`
      if (this.usuario) parametros += `&usuario=${this.usuario}`
      if (this.tipo) parametros += `&tipo=${this.tipo}`
      if (this.distribuidor && !this.integrador) parametros += `&distribuidor=${this.distribuidor}`
      if (this.integrador) parametros += `&integrador=${this.integrador}`
      if (this.etapa) parametros += `&etapa=${this.etapa}`
      if (this.cliente) parametros += `&cliente=${this.cliente}`

      await Api.get(`oportunidades${parametros}`)
        .then(res => {
          this.total = res.data.total
          this.dados = []
          res.data.data.map(oportunidade => {
            this.dados.push({
              opu_id: oportunidade.opu_id,
              cliente: oportunidade.cliente,
              dono: oportunidade.usuario ? oportunidade.usuario.usu_nome : '',
              status: this.statuses[oportunidade.opu_status - 1],
              opu_criado_em: this.retornaTempoAbertura(oportunidade.opu_criado_em),
              etapa: this.retornaEtapa(oportunidade),
              tipo: this.tiposDeOportunidade[oportunidade.opu_tipo - 1].text,
              chance: this.chances[oportunidade.opu_probabilidade - 1],
              opu_observacao: this.limitaTexto(oportunidade.opu_observacao),
              valor: this.retornaValorMedio(oportunidade.pos_total),
              tarefa: oportunidade.proxima_tarefa,
              integrador: oportunidade.integrador,
              uuid: oportunidade.uuid_opu_id
            })
          })
          this.carregando = false
          this.loading = false
        })
        .catch(err => {
          console.log(err)
          this.loading = false
          this.carregando = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar as oportunidades!',
            color: 'error'
          })
        })
    },
    retornaValorMedio (valor) {
      if (!valor) return ' - '
      return this.$root.Formatter.floatToMoney(valor)
    },
    retornaTarefa (tarefa) {
      if (!tarefa) return ' - '
      return tarefa.tar_descricao
    },
    retornaTempoAbertura (dataCriacao) {
      const hoje = moment()
      const criacao = moment(dataCriacao)
      const diasAbertos = hoje.diff(criacao, 'days')
      return diasAbertos > 1 ? `${diasAbertos} dias` : `${diasAbertos} dia`
    },
    retornaEtapa (oportunidade) {
      if (!oportunidade.etapas || !oportunidade.etapas.length) return ' - '

      let nomeEtapa = ' - '
      let funilAtual = 1

      if (oportunidade.opu_status === 3) funilAtual = 2
      oportunidade.etapas.map(etapa => {
        if (etapa.fk_fun_id_funil === funilAtual) nomeEtapa = etapa.fet_nome
      })
      return nomeEtapa
    },
    limitaTexto (texto) {
      if (!texto || texto.length <= 75) return texto
      return `${texto.substr(0, 74)}...`
    },
    async getUsuarios () {
      this.loadingUsuarios = true
      await Api.get('usuarios')
        .then(res => {
          if (res.data) {
            res.data.map(user => {
              this.usuarios.push({
                value: user.uuid_usu_id,
                text: user.usu_nome
              })
            })
          }
          this.loadingUsuarios = false
        })
        .catch(err => {
          this.loadingUsuarios = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os usuários!',
            color: 'error'
          })
        })
    },
    async getDistributors () {
      this.loadingDistribuidores = true
      Api.get('distribuidores')
        .then(res => {
          if (res.data && res.data.length > 0) {
            let info = []
            res.data.map(item => {
              info.push({
                value: item.uuid_dis_id,
                text: item.dis_nome_fantasia
              })
            })
            this.distribuidores = info
            this.loadingDistribuidores = false
          }
        })
        .catch(err => {
          this.loadingDistribuidores = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os distribuidores!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getIntegrators (distribuidor = null) {
      this.loadingIntegradores = true
      let url = 'integradores'

      if (distribuidor) {
        url = `distribuidores/${distribuidor}/integradores`
      }
      await Api.get(url)
        .then(res => {
          var arrayInt = []
          res.data.map(int => {
            arrayInt.push({
              'text': int.int_nome,
              'value': int.uuid_int_id
            })
          })

          this.integradores = arrayInt
          this.loadingIntegradores = false
        })
        .catch(err => {
          this.loadingIntegradores = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os integradores!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getFunis () {
      let parametros = ''
      if (this.$root.Permissions.admin()) {
        parametros = `?integrador=${this.integrador}`
      }
      await Api.get(`funis${parametros}`)
        .then(res => {
          if (res.data && res.data.length > 0) {
            this.funis = res.data
          }
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os funis!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getEtapas () {
      if (this.funis.length === 0) return

      this.loadingEtapas = true

      this.funil = this.funis[0].uuid_fun_id
      if (this.status === 3) {
        this.funil = this.funis[1].uuid_fun_id
      }

      let parametros = ''
      if (this.$root.Permissions.admin()) {
        parametros = `?integrador=${this.integrador}`
      }

      const endpoint = `funis/etapas/funil/${this.funil}${parametros}`
      await Api.get(endpoint)
        .then(async res => {
          if (res.data && res.data.length > 0) {
            let info = []
            res.data.map(item => {
              info.push({
                value: item.uuid_fet_id,
                text: item.fet_nome
              })
            })
            this.etapas = info
            this.loadingEtapas = false
          }
        })
        .catch(err => {
          this.loadingEtapas = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os dados!',
            color: 'error'
          })
          console.log(err)
        })
    },
    handleColunaStatus () {
      if (!this.cliente) return
      this.headers.splice(3, 0, { text: 'Status', value: 'status' })
    },
    removeHeader () {
      if (!this.$root.Permissions.admin()) {
        delete this.headers[10]
      }
    },
    async loadContent () {
      let filters = this.$route.query
      if (filters.de) this.de = filters.de
      if (filters.ate) this.ate = filters.ate
      if (this.de) {
        this.data_entrada.start = this.de
        if (this.ate) {
          this.data_entrada.end = this.ate
        }
      }
      if (filters.busca) {
        this.search = filters.busca
        this.searchFinal = filters.busca
      }
      if (filters.usuario) this.usuario = filters.usuario
      if (filters.tipo) this.tipo = filters.tipo
      if (filters.distribuidor) this.distribuidor = filters.distribuidor
      if (filters.integrador) this.integrador = filters.integrador
      if (filters.etapa) this.etapa = filters.etapa
      if (this.$root.Permissions.admin()) {
        this.getDistributors()
        this.getIntegrators(this.distribuidor)
      }
      if (this.$root.Permissions.integrator() || this.integrador) {
        await this.getFunis()
        await this.getEtapas()
      }
      // this.getUsuarios()
    }
  },
  created () {
    this.removeHeader()
    this.handleColunaStatus()
    this.loadContent()
  }
}
</script>
<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
.item {
  &-link {
    cursor: pointer;
    transition: 0.3s ease;
    &:hover {
      color: $primary;
      transition: 0.3s ease;
    }
  }
}
.v-chip {
  width: 70px;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/oportunidades/ListaOportunidades.vue